export default __webpack_public_path__ + "static/media/world-cup-two-banner.f82d6643.webp";